// GA4 + Meta Pixel event tracking utility

const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
};

const fbTrack = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq("track", eventName, params);
  }
};

const buildItems = (items, language) =>
  items.map((item) => ({
    item_id: String(item.id || item.slug),
    item_name: language === "en" ? item.name_en : item.name_ar,
    price: parseFloat(item.price),
    quantity: item.qty || 1,
  }));

export const trackViewItem = (product, language) => {
  const value = parseFloat(product.price);
  trackEvent("view_item", {
    currency: "SAR",
    value,
    items: [
      {
        item_id: String(product.id || product.slug),
        item_name: language === "en" ? product.name_en : product.name_ar,
        price: value,
        quantity: 1,
      },
    ],
  });
  fbTrack("ViewContent", {
    content_ids: [String(product.id || product.slug)],
    content_name: language === "en" ? product.name_en : product.name_ar,
    content_type: "product",
    currency: "SAR",
    value,
  });
};

export const trackAddToCart = (product, qty, language) => {
  const value = parseFloat(product.price) * qty;
  trackEvent("add_to_cart", {
    currency: "SAR",
    value,
    items: [
      {
        item_id: String(product.id || product.slug),
        item_name: language === "en" ? product.name_en : product.name_ar,
        price: parseFloat(product.price),
        quantity: qty,
      },
    ],
  });
  fbTrack("AddToCart", {
    content_ids: [String(product.id || product.slug)],
    content_name: language === "en" ? product.name_en : product.name_ar,
    content_type: "product",
    currency: "SAR",
    value,
  });
};

export const trackViewCart = (cartItems, total, language) => {
  trackEvent("view_cart", {
    currency: "SAR",
    value: parseFloat(total),
    items: buildItems(cartItems, language),
  });
};

export const trackBeginCheckout = (cartItems, total, language) => {
  const value = parseFloat(total);
  trackEvent("begin_checkout", {
    currency: "SAR",
    value,
    items: buildItems(cartItems, language),
  });
  fbTrack("InitiateCheckout", {
    content_ids: cartItems.map((i) => String(i.id || i.slug)),
    currency: "SAR",
    value,
    num_items: cartItems.length,
  });
};

export const trackPurchase = (orderId, orderItems, totalPrice, shippingPrice, language) => {
  // GA4 `purchase` is sent SERVER-SIDE via the Measurement Protocol
  // (MoyasarController@verify) so revenue is captured reliably even when the
  // visitor's browser blocks Google Analytics. Here we only fire the Meta Pixel.
  const key = `purchase_fired_${orderId}`;
  if (sessionStorage.getItem(key)) return;

  const value = parseFloat(totalPrice) || 0;
  const list = orderItems || [];
  if (typeof window.fbq === "function") {
    window.fbq("track", "Purchase", {
      content_ids: list.map((i) => String(i.id || i.slug)),
      content_type: "product",
      currency: "SAR",
      value,
    });
    sessionStorage.setItem(key, "1");
  }
};

export const trackSearch = (searchTerm) => {
  if (searchTerm) {
    trackEvent("search", { search_term: searchTerm });
    fbTrack("Search", { search_string: searchTerm });
  }
};
